import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from "jwt-decode";
import { useLocation, useNavigate } from 'react-router-dom';

// Create a context for authentication
const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Retrieve the access token from localStorage on component mount
    const token = localStorage.getItem('access_token');
    // todo check validity of token, instead of just checking if it exists
    if (token && !(location?.pathname === "/about")) {
      if (isTokenExpired(token)) {
        setIsAuthenticated(false);
        navigate("/login");
      }  else {
        setIsAuthenticated(true);
      } 
    }
  },[]);

  useEffect(() => {
    // Retrieve the access token from localStorage on component mount
    const token = localStorage.getItem('access_token');
    // todo check validity of token, instead of just checking if it exists
    if (token && !(location?.pathname === "/about")) {
      if (isTokenExpired(token)) {
        setIsAuthenticated(false);
        navigate("/login");
      }  else {
        setIsAuthenticated(true);
      } 
    }
  },[location]);

  const isTokenExpired = (token) => {
    if (!token) return true;
    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      return decodedToken.exp < currentTime;
    } catch (error) {
      console.error('Error decoding token:', error);
      return true;
    }
  };

  const login = (token) => {
    localStorage.setItem('access_token', token);
    setIsAuthenticated(true);
    navigate("/my-evaluations");
  };

  const logout = () => {
    localStorage.removeItem('access_token');
    setIsAuthenticated(false);
    navigate("/login");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
